import { DOMAIN } from "./../utilities/consts";

class DashboardApi {
  static getDashboardData = config => {
    return fetch(`${DOMAIN}/ZeekAppsWS.asmx/ObtenerDatosDashboard`, {
      method: "POST",
      body: JSON.stringify(config),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      credentials: "include"
    })
      .then(response => response.json())
      .then(data => JSON.parse(data.d));
  };

  static getDashboardDataFake = config => {
    return fetch("/fakedata/dashboard.json")
      .then(response => response.json())
      .then(data => data);
  };

  static getDashboardConfiguration = () => {
    return fetch(`${DOMAIN}/ZeekAppsWS.asmx/ObtenerConfiguracionDashboard`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      credentials: "include"
    })
      .then(response => response.json())
      .then(data => JSON.parse(data.d));
  };

  static getDashboardConfigurationFake = () => {
    return fetch(`/fakedata/dashboardConfiguration.json`)
      .then(response => response.json())
      .then(data => data);
  };

  static saveDashboardConfigurationFake = config => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ ...config.configuracion });
      }, 1000);
    });
  };

  static saveDashboardConfiguration = config => {
    return fetch(`${DOMAIN}/ZeekAppsWS.asmx/GuardarConfiguracionDashboard`, {
      method: "POST",
      body: JSON.stringify(config),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      credentials: "include"
    })
      .then(response => response.json())
      .then(data => JSON.parse(data.d));
  };
}

export default DashboardApi;



// WEBPACK FOOTER //
// ./src/api/dashboardApi.js